
import React from 'react';
import { Button, Col, Row } from 'reactstrap';
import EsteiraComponent from './EsteiraComponent';
/* eslint-disable */


function Segundo(props) {
	const {step, setStep, typeSelected, setTypeSelected, setSubTitle ,verifyType = () => console.log("")} = props;

	return (
		<div className="content-center">
			<p className="pb-3 pl-4">Como forma de segurança, precisaremos validar seu acesso com um código Token. </p>

			<p className="pl-4">Escolha como receber em uma das opções abaixo:</p>
			<Row className="rowButton px-4">
				<Col className="">
					<Button
						style={{ minHeight: '40px', paddingTop: '8px', paddingBottom: '8px' }}
						className="buttonComponentOutline px-5"
						onClick={() => {
							verifyType('email')
						}}>
						E-MAIL
					</Button>
				</Col>
				<Col className="">
					<Button
						style={{ minHeight: '40px', paddingTop: '8px', paddingBottom: '8px' }}
						className="buttonComponentOutline"
						onClick={() => {
							verifyType('sms')
							}}>
						MENSAGEM SMS
					</Button>
				</Col>
			</Row>
			<EsteiraComponent step={step} />


			<Row className="rowButton">
				<Col>
					<Button
						outline
						color="primary"
						className="buttonComponentOutline  px-5"
						onClick={() => {
							setTypeSelected('')
							setStep(1)
							setSubTitle("")
							}}>
						VOLTAR
					</Button>
				</Col>

				<Col>
					<Button
						color="primary"
						className="buttonComponent px-5"
						disabled
						onClick={() => console.log("")}>
						ENVIAR
					</Button>
				</Col>
			</Row>
		</div>
	);
}

export default Segundo;
